<template>
  <div class="page-container">
    <div class="page-title">
      {{ $t('menu.merchant_list') }}
    </div>
    <div class="pay-trans-details">
      <div class="filter-section-container">
        <div class="filter-fixed">
          <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
          <i
            class="el-icon-arrow-down filter-fixed-arrow"
            :class="{'fiter-icon-arrow-route':!showFilterContent}"
            @click="onClickFixedArrow"
          />
        </div>
        <el-collapse-transition>
          <div v-show="showFilterContent">
            <div id="filter-content" class="filter-content">
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('merchant.merchant_no') + '/' + $t('merchant.merchant_name') }}</div>
                <el-input v-model="search.auth_merchant_no_or_name" size="small" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('components.status') }}</div>
                <el-select v-model="search.auth_status" class="filter-item-value" size="small" clearable>
                  <el-option
                    v-for="(item,index) in authorizationStatus"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>

              <div class="filter-item"/>
            </div>
            <div class="filter-operate">
              <div class="filter-operate-left">
                <!-- <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button> -->
              </div>
              <div class="filter-operate-right">
                <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
                <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
              </div>

            </div>
          </div>

        </el-collapse-transition>
      </div>
      <div class="tableContainer">
        <!-- 列表 -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
        >

          <el-table-column :label="$t('merchant.merchant_no')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.auth_merchant_no }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchant.merchant_name')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.auth_merchant_name }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('serviceProvider.register_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.registration_time }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('serviceProvider.authorization_status')" align="center">
            <template slot-scope="scope">
              <span>{{ getAuthorizationStatusLabel(scope.row.auth_status) }}</span>
            </template>
          </el-table-column>

          <!--操作-->
          <el-table-column :label="$t('components.operation')" align="center" min-width="100">
            <template slot-scope="scope">
              <el-button v-if="scope.row.auth_status === 2" type="text" @click="$router.push({ name: 'Transaction_Records', params: { merchant_no: scope.row.auth_merchant_no, merchant_name: scope.row.auth_merchant_name } })">{{ $t('menu.transaction_records') }}</el-button>
            </template>
          </el-table-column>

        </el-table>

        <div class="pagination-container">
          <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getMchMerchantPartnerList } from '@/api/service-provider-tools/service-provider-tools'

import { authorizationStatus } from '@/maps/status.js'
import { filterEmptyAttr } from '@/utils/common'

export default {
  name: 'Merchant_List',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
  },
  data() {
    return {
      showFilterContent: true,
      search: {},
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      }
    }
  },
  computed: {
    authorizationStatus() {
      return authorizationStatus()
    },
    getAuthorizationStatusLabel() {
      return (val) => {
        return authorizationStatus(val).label
      }
    }
  },
  created() {
    this.handleFilter()
  },
  methods: {
    getTableData(params) {
      this.listLoading = true
      getMchMerchantPartnerList(params).then(res => {
        // eslint-disable-next-line no-unused-vars
        const { total = 15, list = [] } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      let params = {
        ...this.search,
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },
    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getTableData(params)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container{
  margin: 40px 57px 50px 32px;
}
.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
.pay-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    width: 230px
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }
}
.is-disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.is-disabled:hover {
  color: #98A1B4;
}
</style>
